<div #createUserContainer class="create-user-container">
  <h3 class="text-center everheader">Create New User</h3>
  <div class="mt-4">
    <p>
      Please enter the following details to create a new user to access Control
      Centre.
    </p>
  </div>
  <div class="container my-3">
    <form [formGroup]="newUserFormGroup">
      <div class="row section">
        <div class="col-2">
          <h4 class="form-label mt-3">Name</h4>
        </div>
        <div class="col">
          <div class="d-flex align-items-start mt-3">
            <div>
              <mat-form-field class="editor title-field">
                <mat-label>Title</mat-label>
                <mat-select
                  formControlName="title"
                  id="title"
                  [panelWidth]="null"
                >
                  <mat-option></mat-option>
                  <mat-option
                    *ngFor="let title of titles"
                    [value]="title.value"
                  >
                    {{ title.viewValue }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="mx-sm-3">
              <mat-form-field class="editor">
                <mat-label>First Name</mat-label>
                <input
                  type="text"
                  matInput
                  formControlName="firstName"
                  id="firstName"
                  required
                />
                <mat-error
                  *ngIf="
                    form.firstName.invalid &&
                    (form.firstName.dirty || form.firstName.touched)
                  "
                  class="invalid-feedback"
                >
                  <div *ngIf="form.firstName.errors.required">
                    First Name is required.
                  </div>
                  <div *ngIf="form.firstName.errors.maxlength">
                    Name must be no more than 64 characters long.
                  </div>
                  <div *ngIf="form.firstName.errors.pattern">
                    Invalid characters in the name.
                  </div>
                </mat-error>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="editor">
                <mat-label>Last Name</mat-label>
                <input
                  type="text"
                  matInput
                  formControlName="lastName"
                  id="lastName"
                  required
                />
                <mat-error
                  *ngIf="
                    form.lastName.invalid &&
                    (form.lastName.dirty || form.lastName.touched)
                  "
                  class="invalid-feedback"
                >
                  <div *ngIf="form.lastName.errors.required">
                    Last Name is required.
                  </div>
                  <div *ngIf="form.lastName.errors.maxlength">
                    Name must be no more than 64 characters long.
                  </div>
                  <div *ngIf="form.lastName.errors.pattern">
                    Invalid characters in the name.
                  </div>
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="row section mt-3">
        <div class="col-2">
          <h4 class="form-label mt-3">Email Address</h4>
        </div>
        <div class="col">
          <div class="mt-3">
            <div class="mb-1">
              <mat-form-field class="email-input-field">
                <mat-label>Email Address</mat-label>
                <input
                  type="email"
                  matInput
                  formControlName="emailAddress"
                  id="emailAddress"
                  required
                />
                <mat-error
                  *ngIf="
                    form.emailAddress.invalid &&
                    (form.emailAddress.dirty || form.emailAddress.touched)
                  "
                  class="invalid-feedback"
                >
                  <div *ngIf="form.emailAddress.errors.required">
                    Email Address is required.
                  </div>
                  <div *ngIf="form.emailAddress.errors.maxlength">
                    Email Address must be no more than 128 characters long.
                  </div>
                  <div *ngIf="form.emailAddress.errors.email">
                    Invalid email address.
                  </div>
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="row section mt-3">
        <div class="col-2">
          <h4 class="form-label mt-3 text-nowrap">Contact Number</h4>
        </div>
        <div class="col">
          <div class="d-flex align-items-start mt-3">
            <mat-form-field class="editor-phone">
              <mat-label>Phone</mat-label>
              <input
                type="tel"
                matInput
                formControlName="contactPhone"
                id="contactPhone"
              />
              <span class="editor-phone-countrycode mr-1" matTextPrefix>{{
                countryCode$ | async
              }}</span>
              <mat-error
                class="invalid-feedback"
                *ngIf="
                  form.contactPhone.invalid &&
                  (form.contactPhone.dirty || form.contactPhone.touched)
                "
              >
                <div *ngIf="form.contactPhone.errors.required">
                  Phone Number is required.
                </div>
                <div *ngIf="form.contactPhone.errors.pattern">
                  Only digits are accepted for phone numbers. Please retry.
                </div>
                <div *ngIf="form.contactPhone.errors.maxlength">
                  Phone number entered is too long. Please retry.
                </div>
                <div *ngIf="form.contactPhone.errors.invalidphone">
                  Phone number entered is invalid. Please retry.
                </div>
              </mat-error>
            </mat-form-field>
            <mat-form-field class="editor-phone-ext ml-1">
              <mat-label>Ext</mat-label>
              <input
                type="tel"
                matInput
                formControlName="contactPhoneExt"
                id="contactPhoneExt"
                [readonly]="!form.contactPhone.value"
              />
            </mat-form-field>
          </div>
          <mat-error
            class="invalid-feedback"
            *ngIf="
              form.contactPhoneExt.invalid &&
              (form.contactPhoneExt.dirty || form.contactPhoneExt.touched)
            "
          >
            <div *ngIf="form.contactPhoneExt.errors.pattern">
              Only digits are accepted for phone extension. Please retry.
            </div>
            <div *ngIf="form.contactPhoneExt.errors.maxlength">
              Phone extension entered is too long. Please retry.
            </div>
          </mat-error>
        </div>
      </div>
      <div class="row mt-3">
        <p>
          Set Role of the new account to Admin if you want the user to have
          Admin access.<br />This will enable user to create and manage users
          within the hospital.
        </p>
      </div>
      <div class="row section">
        <div class="col">
          <div class="row">
            <div class="col-2">
              <h4 class="form-label mt-3">Role</h4>
            </div>
            <div class="col">
              <div class="my-3" formGroupName="rolesCheckboxGroup">
                <div
                  *ngFor="let role of roles; let ind = index"
                  [ngClass]="{ 'mb-3': ind !== roles.length - 1 }"
                >
                  <mat-checkbox
                    [formControlName]="
                      RoleMappingService.getRoleEnum(role.name)
                    "
                    [id]="RoleMappingService.getRoleEnum(role.name)"
                    >{{
                      RoleMappingService.getRoleDisplayName(role.name)
                    }}</mat-checkbox
                  >
                </div>
                <div
                  class="invalid-feedback"
                  *ngIf="
                    form.rolesCheckboxGroup.touched &&
                    form.rolesCheckboxGroup.errors &&
                    form.rolesCheckboxGroup.errors.requireCheckboxesToBeChecked
                  "
                >
                  The user must have at least one role selected.
                </div>
                <div
                  class="invalid-feedback"
                  *ngIf="hasSiteSpecificRoles() && numSiteSelected() === 0"
                >
                  The user must have at least one site selected.
                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="hasSiteSpecificRoles()">
            <div class="col-2">
              <h4 class="form-label mt-3">Sites</h4>
            </div>
            <div class="col">
              <div class="mt-3 pt-1">
                Please select the sites you want to grant access to
              </div>
            </div>
          </div>
          <div class="row" *ngIf="hasSiteSpecificRoles()">
            <div class="col-2"></div>
            <div class="col pb-3">
              <app-site-permission-editor-v2
                [allSites]="sitesForCurrentOrg()"
                [defaultSite]="selectedDefaultSiteId()"
                [permittedSiteIds]="permittedSiteIds()"
                (sitePermissionChanged)="onSitePermissionChanged($event)"
              ></app-site-permission-editor-v2>
            </div>
          </div>
          <div class="row" *ngIf="hasSiteSpecificRoles()">
            <div class="col-2">
              <h4 class="form-label mt-3">Default Site</h4>
            </div>
            <div class="col">
              <div class="mt-3">
                <mat-form-field class="default-site-container editor">
                  <mat-label>{{
                    sitesForCurrentOrg().length > 1 ? 'Select Site' : ''
                  }}</mat-label>
                  <mat-select
                    formControlName="defaultSite"
                    id="defaultSite"
                    [panelWidth]="null"
                  >
                    <mat-option [value]="0">No Default</mat-option>
                    <mat-option
                      *ngFor="let sitePermissionInfo of permittedClientSites()"
                      [value]="sitePermissionInfo.siteId"
                    >
                      {{ sitePermissionInfo.siteName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-2">&nbsp;</div>
        <div class="col">
          <div>
            <button
              type="button"
              [disabled]="saving"
              class="everbtnmain"
              (click)="submit()"
            >
              Create
            </button>

            <button
              type="button"
              [disabled]="saving"
              class="everbtn"
              (click)="cancelWindow()"
            >
              Cancel
            </button>
            <mat-spinner *ngIf="saving" diameter="32">Saving...</mat-spinner>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-2">&nbsp;</div>
        <div class="col">
          <mat-checkbox
            formControlName="isToCreateAnotherUser"
            id="isToCreateAnotherUser"
            >Create another user
          </mat-checkbox>
        </div>
      </div>
    </form>
  </div>
</div>
